<template>
    <div class="fzg-chuangfu-pc">
      <div class="fzg-banner">
        <fzg-menu/>
        <div class="sologan"></div>
      </div>
      <div class="fzg-cf-business">
        <div class="bus-wrap">

          <div class="bus-item">
            <img class="logo" src="../../assets/img2/pc/chuangfu/logo2.png" alt="">
            <div class="name">创投媒体</div>
          </div>

          <div class="bus-item">
            <img class="logo" src="../../assets/img2/pc/chuangfu/logo8.png" alt="">
            <div class="name">产业峰会</div>
          </div>

          <div class="bus-item">
            <img class="logo" src="../../assets/img2/pc/chuangfu/logo6.png" alt="">
            <div class="name">路演论坛</div>
          </div>

          <div class="bus-item">
            <img class="logo" src="../../assets/img2/pc/chuangfu/logo5.png" alt="">
            <div class="name">创投培训</div>
          </div>

          <div class="bus-item">
            <img class="logo" src="../../assets/img2/pc/chuangfu/logo1.png" alt="">
            <div class="name">创业孵化</div>
          </div>


          <div class="bus-item">
            <img class="logo" src="../../assets/img2/pc/chuangfu/logo3.png" alt="">
            <div class="name">产业咨询</div>
          </div>


          <div class="bus-item">
            <img class="logo" src="../../assets/img2/pc/chuangfu/logo4.png" alt="">
            <div class="name">商机对接</div>
          </div>

          <div class="bus-item">
            <img class="logo" src="../../assets/img2/pc/chuangfu/logo7.png" alt="">
            <div class="name">飞地运营</div>
          </div>


          <div class="bus-item">
            <img class="logo" src="../../assets/img2/pc/chuangfu/logo9.png" alt="">
            <div class="name">投融资数据库</div>
          </div>

          <div class="bus-item">
            <img class="logo" src="../../assets/img2/pc/chuangfu/logo10.png" alt="">
            <div class="name">人才对接</div>
          </div>
        </div>

      </div>

      <!-- 业务介绍 -->
      <!-- @todo content data -->
      <div class="cf-intro">
        <div class="cf-intro-left">
          <div class="intro-title" :class="{'intro-title-active' : activeIntro == 0}" @click="activeIntro = 0">ROADSHOW</div>
          <div class="intro-title" :class="{'intro-title-active' : activeIntro == 1}" @click="activeIntro = 1">小饭局</div>
          <div class="intro-title" :class="{'intro-title-active' : activeIntro == 2}" @click="activeIntro = 2">创业课堂</div>
          <div class="intro-title" :class="{'intro-title-active' : activeIntro == 3}" @click="activeIntro = 3">区域经济与政策支持</div>
        </div>
        <div class="cf-intro-right">
          <div class="intro-title">
            <img src="../../assets/img2/pc/chuangfu/title-business.png" alt="">
          </div>
          <div class="intro-content">
            <template v-if="activeIntro == 0">
              <p>小饭桌ROADSHOW是凡卓集团旗下小饭桌创服重磅推出的高质量创业项目路演活动，聚焦前沿科技与数字经济，持续挖掘产业增长引擎，帮助优质创业项目深度链接多元投资机构与区域产业资源，打造精准、高效、深度的产业交流平台。</p>
              <br>
              <p>依托于凡卓集团自身影响力与投融资服务的专业能力，将优质创业项目与多元投资机构深度链接。根据城市产业格局精细化定制路演项目筛选标准，匹配高效精准。</p>
            </template>

            <template v-if="activeIntro == 1">
              <p>小饭局是由小饭桌打造的行业主题沙龙，聚焦新一代信息技术、新能源、新材料、先进制造、企业服务、生命科学等方向。</p>
              <br>
              <p>以线上研讨会、线下闭门会和饭局漫谈等多种有趣有料的交流形式为桌友提供观点交换的平台和高质量社交的场域。</p>
            </template>
            <template v-if="activeIntro == 2">
              <p>龙头企业深度参访、产业及技术深度介绍及交流，实体参览；龙头企业创始人进行深度企业发展历程及行业分享；核心业务线高管从企业经营、渠道营销等维度分享实操经验；现场进行业务建议与合作探讨，快速落地合作。</p>
            </template>
            <template v-if="activeIntro == 3">
              <p>深耕中国新兴产业，基于“产业深度研究+投融资大数据”，为中国产业参与者提供一揽子综合服务;面向城市管理者、产业投资者和优秀创业者，提供城市级产业战略方案、市场进入、园区规划、产业并购整合与战略咨询服务、创业企业经营布局与融资一体化解决方案、项目可行性研究、数字化转型及其他配套产业研究与解决方案。</p>
            </template>
          </div>
        </div>
      </div>


      <div class="cf-media">
        <img class="media-title" src="../../assets/img2/pc/chuangfu/title-media.png" alt="">
        <div class="media-intro">
          小饭桌公众号拥有 <span class="num">30万+</span> 高净值粉丝，<span class="num">100%</span> 覆盖一线投资机构 <br>
          内容全网曝光量累计 <span class="num">1亿+</span>，超过 <span class="num">2000+</span> 企业通过小饭桌创服媒体的报道成功获得融资
        </div>
        <div class="media-list">
          <div class="media-item">
            <div class="wechat-code">
              <img src="https://www.xfz.cn/static/build/images/xfz-wechat-share.png">
              <div class="wechat-name">小饭桌公众号</div>
            </div>
            <img class="logo" src="../../assets/img2/pc/chuangfu/media-wechat.png" alt="">
            <div class="name">公众号</div>
          </div>

          <div class="media-item">
            <a href="https://xfz.cn" target="_blank">
              <img class="logo" src="../../assets/img2/pc/chuangfu/media-pc.png" alt="">
              <div class="name">门户网站</div>
            </a>
          </div>

          <div class="media-item" @click="isShowModal = true">
            <img class="logo" src="../../assets/img2/pc/chuangfu/media-metrics.png" alt="">
            <div class="name">平台矩阵</div>
          </div>
        </div>
        <div class="media-other">
          <a class="item" href="https://mp.weixin.qq.com/mp/appmsgalbum?__biz=MzA3OTMxMDUzOQ==&action=getalbum&album_id=2850012663396220928" target="_blank">
            <img src="../../assets/img2/pc/chuangfu/card-tzrs.jpg" alt="">
          </a>

          <a class="item" href="https://mp.weixin.qq.com/mp/appmsgalbum?__biz=MzA3OTMxMDUzOQ==&action=getalbum&album_id=1332421567602851841&scene=126#wechat_redirect" target="_blank">
            <img src="../../assets/img2/pc/chuangfu/card-cyzs.jpg" alt="">
          </a>
        </div>
      </div>

      <fzg-chuang-fu-metrics-modal
        v-if="isShowModal"
        @hide-modal="isShowModal = false"/>
    </div>
</template>

<script>

import util from '../../assets/js/util'
import FzgMenu from '../common/FzgMenu.vue'
import FzgChuangFuMetricsModal from './FzgChuangFuMetricsModal.vue'

export default{
    components:{ FzgMenu, FzgChuangFuMetricsModal},
    props:[''],
    data(){
        return{
          activeIntro: 0,
          isShowModal: false,
        }
    },
    methods:{

    },
    mounted(){
    },
    watch: {
      'fzTeamList': function() {
      },
    },

}
</script>

<style lang="scss">
.fzg-chuangfu-pc {
  .fzg-banner {
    // border: 1px solid red;
    // background: url(../../assets/img2/pc/chuangfu/banner.png) no-repeat;
    // background: url(https://static-image.xfz.cn/1686266471355/cf-bn.png) no-repeat;
    background: url(https://static-image.xfz.cn/1687734821262/service_banner.png) no-repeat;
    background-size: auto;
    background-position: bottom;
    height: 340px;
    position: relative;
    .sologan {
      // border: 1px solid red;
      width: 500px;
      height: 120px;
      background-image: url(../../assets/img2/pc/chuangfu/sologan.png);
      background-repeat: no-repeat;
      background-size: 100% auto;
      color: white;
      margin: 50px auto;
    }
  }
  .fzg-cf-business {
    background: #f6f9ff;
    padding-top: 80px;
    padding-bottom: 80px;

    .bus-wrap {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      margin: 0px auto;
      // border: 1px solid red;
      width: 900px;
      height: 360px;
      .bus-item {
        // border: 1px solid #ccc;
        text-align: center;
        height: 170px;
        width: 170px;
        .logo {
          width: 100px;
        }
      }
    }
  }

  .cf-intro {
    // border: 1px solid red;
    width: 1100px;
    margin: 80px auto 80px;
    .cf-intro-left {
      width: 300px;
      display: inline-block;
      vertical-align: top;
      margin-right: 10px;
      .intro-title {
        height: 80px;
        line-height: 80px;
        border-bottom: 1px solid #ccc;
        padding-left: 20px;
        cursor: pointer;
        &:first-child {
          border-top: 1px solid #ccc;
        }
      }
      .intro-title-active {
        color: white;
        background-color: #d0ab6c;
        position: relative;
        &::after {
          content: 'ㄱ';
          position: absolute;
          color: white;
          right: 20px;
          top: 0px;
          transform: rotate(45deg);
        }
      }
    }
    .cf-intro-right {
      width: 750px;
      display: inline-block;
      border-top: 1px solid #ccc;
      border-bottom: 1px solid #ccc;
      padding: 0px 20px 20px;
      min-height: 320px;
      .intro-title {
        margin-top: 15px;
      }
      .intro-content {
        letter-spacing: 1px;
        padding: 20px 10px;
        text-align: justify;
      }
    }
  }

  .cf-media {
    // border: 1px solid #ccc;
    height: 900px;
    margin: 80px auto 0;
    position: relative;
    .media-title {
      width: 300px;
      position: absolute;
      left: 50%;
      right: 0;
      top: 0px;
      margin-left: -150px;
      // border 1px solid #ce262f;
    }
    .media-intro {
      width: 800px;
      height: 600px;
      position: absolute;
      left: 50%;
      right: 0;
      top: 140px;
      text-align: center;
      margin-left: -400px;
      color: #444444;
      font-size: 18px;
      // border: 1px solid #ededed;
      .num {
        color: #d7ad78;
        font-size: 25px;
        // font-weight: bold;
      }
    }
    .media-list {
      // border: 1px solid #ccc;
      position: absolute;
      width: 1000px;
      height: 300px;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      margin-left: -500px;
      left: 50%;
      top: 260px;
      .media-item {
        // border: 1px solid #ccc;
        text-align: center;
        position: relative;
        width: 260px;
        cursor: pointer;
        .wechat-code {
          position: absolute;
          background-color: #2b2b2b;
          transition: opacity 0.3s ease-in;
          opacity: 0;
          left: 0 ;
          right: 0;
          top: 0;
          bottom: 0;
          img {
            margin-top: 40px;
            width: 180px;
            height: 180px;
          }
          .wechat-name {
            color: white;
            letter-spacing: 6px;
            font-size: 16px;
            margin-top: 20px;
          }
          &:hover {
            opacity: 0.73;
          }
        }
        .logo {
          width: 200px;
        }
        .name {
          font-size: 17px;
        }
      }
    }
    .media-other {
      // border: 1px solid #ccc;
      position: absolute;
      width: 1100px;
      height: 300px;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      margin-left: -550px;
      left: 50%;
      top: 600px;
      .item img{
        width: 530px;
        height: 210px;
        // border: 1px solid #ccc;
        .logo {
          width: 100%;
          height: 100%;
        }
      }
    }
  }


}
</style>



// WEBPACK FOOTER //
// FzgChuangFuPc.vue?0f30277a